package com.eladfinish.bible.contest.screens.mikud

import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.screens.mikud.model.BookState
import com.eladfinish.bible.contest.screens.mikud.model.MikudType
import com.eladfinish.bible.contest.screens.mikud.model.MikudTypeData
import com.eladfinish.bible.contest.screens.mikud.usecases.BuildBooksListUseCase
import com.russhwolf.settings.Settings
import kotlinx.collections.immutable.toImmutableList

/*
interface MikudRepository

class MikudRepositoryImpl(): MikudRepository
 */

class MikudRepository(
    private val buildBooksListUseCase: BuildBooksListUseCase, // TODO: shouldn't be injected here
    private val settings: Settings,
) {

    companion object {

        const val BOOK_SEPARATOR = "#"
        const val CHAPTER_SEPARATOR = ","

        const val UNDERSCORE = "_"
        const val DASH = "-"
    }

    val mikudList: String
        get() = settings.getString(Constants.PREF_MIKUD_LIST, "")
            .takeIf { it.isNotEmpty() }
            ?: buildFullMikud()
                .also {
                    saveMikud(it)
                }

    private fun buildFullMikud(): String =
        mikudToString(buildBooksListUseCase(full = true))

    fun saveMikud(mikudState: List<BookState>): String =
        mikudToString(mikudState).also {
            saveMikud(it)
        }

    private fun saveMikud(mikudString: String) {
        settings.putString(Constants.PREF_MIKUD_LIST, mikudString)
    }

    private fun mikudToString(mikudState: List<BookState>): String =
        mikudState.withIndex().filter { it.value.isNotEmpty() }.joinToString(separator = "\n") {
            "$BOOK_SEPARATOR${it.index.plus(1)}$UNDERSCORE${it.value.english}$DASH" +
                    it.value.chapters.withIndex()
                        .filter { v -> v.value }
                        .joinToString(prefix = "[,", separator = ",", postfix = "]") { v ->
                            ChaptersRepository.padNumber(it.value.english, v.index.plus(1))
                        }
        }

    fun getBookState(): List<BookState> {
        val list = buildBooksListUseCase(full = false).toMutableList()
        mikudList.split("\n")
            .forEach { bookRecord ->
                @Suppress("RegExpRedundantEscape")
                "#(\\d+)_.+?-\\[,(.*)\\]".toRegex().find(bookRecord)?.let { matchResult ->
                    val bookIndex: Int = matchResult.groups[1]!!.value.toInt().minus(1)
                    val includedChapters: List<Int> =
                        matchResult.groups[2]!!.value.split(CHAPTER_SEPARATOR).map { it.toInt().minus(1) }
                    list[bookIndex] = list[bookIndex].copy(
                        chapters = List(list[bookIndex].chapters.size) { it in includedChapters }.toImmutableList()
                    )
                }
            }
        return list
    }

    val mikudimTypes
        get() = listOf(
            MikudTypeData(mikudType = MikudType.FULL, text = """כל התנ"ך"""),
            MikudTypeData(mikudType = MikudType.YOUTH, text = """החומר לחידון התנ"ך לנוער"""),
            MikudTypeData(mikudType = MikudType.ADULTS, text = """החומר לחידון התנ"ך למבוגרים"""),
            MikudTypeData(mikudType = MikudType.SERVER, text = """חידונים נוספים (הורדה מהשרת)"""),
        )

}
